var blockquote_default = {
  "fontElementMap": "zDF2N",
  "quote": "M9eHS"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
